import React from 'react';
import stepleft from 'images/icon/arrow_left_4e4e4e-25x48.png'
import stepright from 'images/icon/arrow_right_4e4e4e-25x48.png'
import {Btmtext, Text, Prev, Arrow, Arrow2} from './style';
export default function StepFooter(props) {
    return(
        <>
        {
            props.next ?
            <Btmtext 
                position={props.position}
                bg={props.bg}
                >
                <Prev onClick={()=>{props.updateNext(-1)}} display={props.prevdisplay}><Arrow><img src={stepleft}></img></Arrow>이전</Prev>
                <Text onClick={props.textClick} color={props.color}>{props.text}</Text>
                <Prev  onClick={()=>{props.updateNext(1)}} display={props.nextdisplay}>다음<Arrow2><img src={stepright}></img></Arrow2></Prev>
            </Btmtext>
            :
            <Btmtext 
                position={props.position}
                bg={props.bg}
                >
                <Prev onClick={()=>{props.updateNext(-1)}}  display={props.prevdisplay}><Arrow><img src={stepleft}></img></Arrow>이전</Prev>
                <Text onClick={props.textClick} color={props.color}>{props.text}</Text>
                <Prev onClick={()=>{}} display={props.nextdisplay}>다음<Arrow2><img src={stepright}></img></Arrow2></Prev>
            </Btmtext>
        }
         </>   
    );
}



